import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AuthorizationService } from "./authorization.service";
import { StorageService } from "./storage.service";
import { ApiDataService } from "./api.service";
import { StudentConstants } from "src/app/feature-modules/student-list/constants/student.constants";

@Injectable()
export class AuthGuardService {
  constructor(
    private _authService: AuthorizationService,
    private router: Router,
    private apiService: ApiDataService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (!StorageService.getToken()) {
      this._authService.logoutWithReturnUrl(state.url);
      return false;
    }

    if (route.data?.denyTutor) {
      try {
        const user = await firstValueFrom(this.apiService.getUserInfo());

        if (Number(user?.role?.id) === Number(StudentConstants.TUTOR_ROLE_ID)) {
          this.router.navigate(["/"]);
          return false;
        }
      } catch {
        this._authService.logoutWithReturnUrl(state.url);
        return false;
      }
    }

    if (localStorage.getItem("previousURL") && this.router.url !== "/") {
      return true;
    }

    return true;
  }
}